// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"a97e79dd","233":"4cdfbe48","369":"df3ebef4","936":"41a39e4d"}[chunkId] + ".css";
};